import React from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import heroImage from '../../assets/images/doctor-real-on-phone.webp';
import sosDottoreLogo from '../../assets/images/logo-dark.png';

const Hero = () => {
  return (
    <section className="hero">
      <Container>
        <Row className="align-items-center">
          <Col md={8} className="hero__content order-1 order-md-1">
            <div className="hero__logo">
              <img src={sosDottoreLogo} alt="Logo SOS Dottore - Assistenza Medica H24" />
            </div>
            <h1 className="hero__title">Il dottore sempre al tuo fianco</h1>
            <h2 className="hero__subtitle">
              La salute a portata di smartphone per te e per tutta la tua
              famiglia 24 ore su 24, 7 giorni su 7.
            </h2>
            <div className="hero__cta">
              <Button
                color="primary"
                size="lg"
                className="hero__button"
                style={{ fontSize: '1rem' }}
                onClick={() => {
                  window.location.href = '#pricing';
                }}>
                Abbonati ora
              </Button>
              <div className="hero__price-container">
                <span className="hero__price-label">A partire da</span>
                <span className="hero__price">
                  <span className="hero__price-currency">€</span>
                  <span className="hero__price-amount">4,90</span>
                  <span className="hero__price-period">/mese</span>
                </span>
              </div>
            </div>
          </Col>
          <Col md={4} className="hero__image order-2 order-md-2">
            <div className="hero__image-container">
              <img
                src={heroImage}
                alt="Medico SOS Dottore disponibile h24 per consulto telefonico e videochiamata"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
        <Row className="hero__bottom-content text-center">
          <Col>
            <div className="hero__assistance">
              L&apos;Assistenza medica quando ne hai bisogno
            </div>
            <h2 className="hero__main-title">
              Prenditi cura di te e della salute della tua famiglia
            </h2>
            <div className="hero__subtitle">
              Scegli la serenità al prezzo di un caffè a settimana.
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Hero;
